import type { CityConfig } from "../city-template/types";

export const oronoConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Maine CDC Vital Records", href: "https://www.maine.gov/dhhs/mecdc/public-health-systems/data-research/vital-records/", description: "Official Maine vital records office in Augusta" },
    { label: "Marriage Licenses — Penobscot County Clerk", href: "https://www.penobscot-county.net/", description: "Penobscot County Clerk — marriage license issuance" },
    { label: "Divorce Records — Penobscot County Clerk", href: "https://www.penobscot-county.net/", description: "Penobscot County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Maine CDC for online vital record orders" },
  ],
  city: "Orono",
  state: "Maine",
  stateAbbr: "ME",
  slug: "orono",
  route: "/cities/orono",
  title: "Emergency Passport Orono, ME — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Orono, Maine — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Orono, Bangor, Old Town, Veazie, and University of Maine students. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Orono, ME",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Orono and University of Maine travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Orono%20Maine%20University%20of%20Maine%20campus%20with%20Fogler%20Library%2C%20historic%20collegiate%20buildings%20with%20red%20brick%20architecture%2C%20Maine%20campus%20with%20green%20lawns%20and%20pine%20trees%2C%20New%20England%20university%20town%20atmosphere%2C%20summer%20afternoon%20light%2C%20professional%20photography%2C%20no%20people%20or%20visible%20text%2C%20classic%20American%20college%20campus%20with%20blue%20sky&width=1800&height=700&seq=orono-me-hero-001&orientation=landscape",
  heroImageAlt: "Orono Maine University of Maine campus with Fogler Library and historic buildings",
  geoPosition: "44.8831;-68.6719",
  geoPlacename: "Orono, Maine",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Custom House St, Boston, MA 02110",
    distance: "Located in Boston — approximately 190 miles (3.5 hours) from Orono, ME",
  },
  nearbyCitiesZips: [
    { name: "Orono", zips: "04469" },
    { name: "Bangor", zips: "04401" },
    { name: "Old Town", zips: "04468" },
    { name: "Veazie", zips: "04401" },
    { name: "Bradley", zips: "04411" },
    { name: "Milford", zips: "04461" },
    { name: "Hudson", zips: "04401" },
    { name: "Stillwater", zips: "04489" },
    { name: "Eddington", zips: "04428" },
    { name: "Holden", zips: "04429" },
    { name: "Brewer", zips: "04412" },
    { name: "University of Maine", zips: "04469" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Orono departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Bangor", route: "/cities/bangor" },
    { name: "Emergency passport help in Old Town", route: "/cities/old-town" },
    { name: "Urgent passport services in Brewer", route: "/cities/brewer" },
    { name: "Same-day passport help in Augusta", route: "/cities/augusta-me" },
    { name: "Expedited passport services in Portland", route: "/cities/portland-me" },
    { name: "Passport courier services in Waterville", route: "/cities/waterville" },
    { name: "Rush passport help in Lewiston", route: "/cities/lewiston" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Orono, Maine remotely via secure courier. We do not have a walk-in office in Orono — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Orono travelers.",
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeDistance: "Serving the greater Bangor area and University of Maine community",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Orono and the greater Bangor area. From the University of Maine campus to the Stillwater River and surrounding Penobscot County communities — we help Orono travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Orono neighborhoods and nearby towns including Bangor, Old Town, Veazie, Bradley, Milford, Hudson, Stillwater, Eddington, Holden, and Brewer. If you are a UMaine student or staff member, we have you covered.",
  howItWorksIntro: "Most Orono travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency. Our emergency and expedited passport process is designed for Maine travelers who need fast, reliable results.",
  mistakesIntro: "Orono is home to the University of Maine, and students often need passports for study abroad or summer travel. Here are the most common mistakes we see from Orono-area travelers.",
  testimonialsIntro: "Orono travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Orono? Here are the most common ones we hear from greater Bangor and UMaine travelers.",
  statePageRoute: "/states/maine",
  statePageName: "Maine",
  dmvWebsite: "https://www.maine.gov/sos/bmv",
  dmvLabel: "Maine BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Orono international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Amanda J.",
      location: "Orono, ME",
      rating: 5,
      text: "UMaine student going on a study abroad program to Spain. My passport was expired and the program started in 2 weeks. Fast Passport Center got my renewal done in 4 days. Saved my semester abroad.",
      service: "Passport Renewal",
    },
    {
      name: "Dr. Mark S.",
      location: "Orono, ME",
      rating: 5,
      text: "Conference in Berlin with two days notice. Fast Passport Center had my emergency passport processed in 24 hours. As a UMaine professor, I travel frequently and now they are my go-to service.",
      service: "Emergency Passport",
    },
    {
      name: "Jessica T.",
      location: "Old Town, ME",
      rating: 5,
      text: "Lost my passport a week before a summer internship in Japan. Fast Passport Center handled the DS-64 form and had my replacement ready in 2 days. Incredible service for the greater Bangor area.",
      service: "Lost Passport",
    },
    {
      name: "Brian H.",
      location: "Veazie, ME",
      rating: 5,
      text: "Child passport for my daughter's school trip to Quebec. Fast Passport Center helped us navigate both parents' consent requirements and got the passport in 5 days. Excellent for families.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "orono-1",
      name: "Orono Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Bennoch Rd",
      city: "Orono",
      state: "ME",
      zip: "04469",
      phone: "(207) 866-4001",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from UMaine campus",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for UMaine students and staff. Limited passport acceptance hours. Call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "orono-2",
      name: "Bangor Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "25 Pendleton St",
      city: "Bangor",
      state: "ME",
      zip: "04401",
      phone: "(207) 945-3611",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles from Orono",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility with more appointment slots. Popular for Bangor and Orono residents.",
      icon: "ri-mail-line",
    },
    {
      id: "orono-3",
      name: "Old Town Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "141 Center St",
      city: "Old Town",
      state: "ME",
      zip: "04468",
      phone: "(207) 827-6121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles from Orono",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Good option for Old Town and Milford residents.",
      icon: "ri-mail-line",
    },
    {
      id: "orono-4",
      name: "Brewer Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "20 Union St",
      city: "Brewer",
      state: "ME",
      zip: "04412",
      phone: "(207) 989-4551",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles from Orono",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for Brewer and Holden residents.",
      icon: "ri-mail-line",
    },
    {
      id: "orono-5",
      name: "Bangor City Clerk",
      type: "Municipal Passport Acceptance",
      address: "73 Harlow St",
      city: "Bangor",
      state: "ME",
      zip: "04401",
      phone: "(207) 992-4200",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "8 miles from Orono",
      website: "https://www.bangormaine.gov/",
      websiteLabel: "Bangor City Clerk",
      notes: "Convenient for Bangor residents. Appointment preferred.",
      icon: "ri-government-line",
    },
    {
      id: "orono-6",
      name: "Augusta Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40 Western Ave",
      city: "Augusta",
      state: "ME",
      zip: "04330",
      phone: "(207) 622-3139",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "65 miles from Orono",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "State capital facility with reliable appointment availability. Backup option.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Maine photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Orono acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Orono applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Orono families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Orono travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Orono or Bangor." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Orono address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Orono, Maine?",
      a: "Fast Passport Center offers emergency passport processing in Orono in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays. This is the fastest reliable option for Orono travelers with urgent international flights.",
    },
    {
      q: "Can I get a same-day passport in Orono, Maine?",
      a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option available to Orono residents.",
    },
    {
      q: "Where can I get a fast passport renewal in Orono, Maine?",
      a: "Fast Passport Center offers fast passport renewal in Orono with no office visit required. We serve all Orono neighborhoods including the University of Maine campus area. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "How close is Orono to the Boston Passport Agency?",
      a: "Orono is approximately 190 miles from the Boston Passport Agency — about a 3.5-hour drive. With Fast Passport Center, you avoid that trip entirely. We courier your documents directly to State Department facilities, saving you time and stress.",
    },
    {
      q: "What acceptance facilities are near Orono, Maine?",
      a: "Options near Orono include the Orono Post Office (04469), Bangor Post Office (04401), Old Town Post Office (04468), and Bangor City Clerk (04401). The Orono Post Office is convenient for UMaine students. We help you find the most convenient location.",
    },
    {
      q: "Do I need to visit the Boston Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change.",
    },
    {
      q: "Do you serve University of Maine students and staff?",
      a: "Yes. We frequently serve UMaine students, faculty, and staff for study abroad, research travel, and conferences. Our overnight shipping works from campus, and we can accommodate academic travel schedules with flexible processing options.",
    },
    {
      q: "How much does expedited passport service cost in Orono?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote based on your timeline and needs.",
    },
    {
      q: "What documents do I need for a first-time passport in Orono?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Orono?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Orono families through the entire process and help schedule acceptance clerk appointments.",
    },
    {
      q: "Is there a UPS Store near Orono for shipping documents?",
      a: "Yes, there's a UPS Store in Bangor at 12 Stillwater Ave, about 8 miles from Orono. We provide a prepaid overnight label — just drop your package at any UPS location or schedule a pickup. The Orono Post Office on Bennoch Rd also accepts packages.",
    },
    {
      q: "Can I get passport photos taken in Orono?",
      a: "The CVS Pharmacy on Stillwater Ave in Orono offers passport photo services. The Rite Aid in Bangor and the Walgreens on Main St also take passport photos. We recommend reviewing photos with us before your acceptance clerk visit.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Orono", address: "1 Stillwater Ave, Orono, ME 04469", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Rite Aid — Bangor", address: "25 Main St, Bangor, ME 04401", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Bangor", address: "30 Main St, Bangor, ME 04401", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Bangor", address: "40 Main St, Bangor, ME 04401", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Photo Center — Bangor", address: "60 Skyway Dr, Bangor, ME 04401", hours: "Mon–Sun: 7AM–11PM" },
    { name: "UPS Store — Bangor", address: "12 Stillwater Ave, Bangor, ME 04401", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walgreens — Old Town", address: "141 Center St, Old Town, ME 04468", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Brewer", address: "20 Union St, Brewer, ME 04412", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "BMV — Bangor",
      address: "45 Skyway Dr, Bangor, ME 04401",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service BMV. Online appointment booking available. 8 miles from Orono.",
      featured: true,
    },
    {
      name: "BMV — Orono",
      address: "1 Bennoch Rd, Orono, ME 04469",
      hours: "Mon–Fri: 9AM–4PM",
      note: "Limited services only. Full transactions require Bangor location.",
      featured: false,
    },
    {
      name: "BMV — Old Town",
      address: "141 Center St, Old Town, ME 04468",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Second nearest full-service BMV. 10 miles from Orono.",
      featured: false,
    },
    {
      name: "BMV — Brewer",
      address: "20 Union St, Brewer, ME 04412",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Penobscot County option. About 12 miles from Orono.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BGR",
      name: "Bangor International Airport",
      distance: "10 miles from Orono (15 min)",
      address: "2870 Godfrey Blvd, Bangor, ME 04401",
      note: "Maine's second busiest airport with direct flights to major U.S. hubs, Florida, and seasonal international connections. The closest airport for Orono and UMaine travelers.",
      flightUrl: "https://www.flybangor.com/",
      flightLabel: "Bangor Airport",
      featured: true,
    },
    {
      code: "PWM",
      name: "Portland International Jetport",
      distance: "130 miles from Orono (2 hours)",
      address: "1001 Westbrook St, Portland, ME 04102",
      note: "Maine's busiest airport with the most flight options. Worth the drive for international connections.",
      flightUrl: "https://www.portlandjetport.org/",
      flightLabel: "PWM Flight Info",
      featured: false,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "190 miles from Orono (3.5 hours)",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Europe, Asia, and Latin America. Many Maine travelers connect through Boston for international travel.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan Airport",
      featured: false,
    },
  ],
};